import axios from '../../v2/app/services/axiosService';

export default {
  async searchSessions(form) {
    const options = {
      params: form,
    };
    const response = await axios.get(`/api/device-sessions`, options);
    return response.data;
  },
  async getSession(sessionID) {
    const response = await axios.get(`/api/device-sessions/${sessionID}`);
    return response.data;
  },
  async getSessionEvents(sessionID) {
    const response = await axios.get(`/api/device-sessions/${sessionID}/events`);
    return response.data;
  },
  async toggleLiveMode(session) {
    const form = {
      live_mode: !session.live_mode,
    };
    const response = await axios.put(`/api/device-sessions/${session.id}`, form);
    return response.data;
  }
}
